import anime from '../../../../assets/scripts/anime.js';
import vidbg from '../../../../assets/scripts/vidbg.js'; // import slick from '../../../../assets/scripts/autoload/slick.js';

$(function () {
  anime({
    targets: '.Hero',
    //translateX: [-20, 0],
    opacity: [0, 1],
    duration: 500,
    easing: 'linear',
    delay: anime.stagger(200, {
      start: 100
    }) // increase delay by 100ms for each elements.

  });
  anime({
    targets: '.Hero-text',
    opacity: [0, 1],
    duration: 750,
    easing: 'linear',
    delay: 100 // increase delay by 100ms for each elements.

  });

  if ($('.Hero--large').length) {
    var instance = new vidbg('.Hero--large', {
      mp4: '/general-images/brentwood_hero_background_web.mp4',
      // URL or relative path to MP4 video
      webm: '/general-images/brentwood_hero_background.webm',
      // URL or relative path to webm video
      poster: '/general-images/fall_back_image.png',
      // URL or relative path to fallback image
      overlay: false,
      // Boolean to display the overlay or not
      overlayColor: '#000',
      // The overlay color as a HEX
      overlayAlpha: 0.3 // The overlay alpha. Think of this as the last integer in RGBA()

    }, {
      // Attributes
      muted: true
    });
  } //Sliders


  $('.frame--feed').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 5000
  });
  $('.GoDown').click(function () {
    $('html, body').animate({
      scrollTop: $('.Transactions-recent').position().top - 83
    }, 750);
  });
  $('.GoDownForm').click(function () {
    $('html, body').animate({
      scrollTop: $('.Event-form').position().top + 100
    }, 750);
  }); //Home Page Animation

  $('#Component_112_29').click(function () {
    $('html, body').animate({
      scrollTop: $('#Component_112_30').position().top - 430
    }, 750);
  });
  $('#Component_112_30').click(function () {
    $('html, body').animate({
      scrollTop: $('#Component_112_33').position().top - 430
    }, 750);
  });
  $('#Component_112_31').click(function () {
    $('html, body').animate({
      scrollTop: $('#Component_112_32').position().top - 280
    }, 750);
  });
  $('#Component_112_32').click(function () {
    $('html, body').animate({
      scrollTop: $('#Component_112_32').position().top - 280
    }, 750);
  });
  $('#Component_112_33').click(function () {
    $('html, body').animate({
      scrollTop: $('#Component_112_31').position().top - 430
    }, 750);
  }); // Home hero animation

  if ($('.Hero--large').length) {
    window.onscroll = function () {
      homeHeroFunction();
    };
  }

  function homeHeroFunction() {
    if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
      // $('#hero').removeClass('is-top');
      // $('#headerLogo').removeClass('is-top');
      // $('#headerNav').removeClass('is-top');
      $('#headerContainer').removeClass('is-top');
    } else {
      // $('#hero').addClass('is-top');
      // $('#headerLogo').addClass('is-top');
      // $('#headerNav').addClass('is-top');
      $('#headerContainer').addClass('is-top');
    }
  }
}); // $(function () {
//     // $(".Hero-autoScroll").click(function() {
//     //     var section = $(this).closest("section");
//     //     var next = section.next("section");
//     //     if (next) {
//     //         var offsetTop = next.offset().top - $("header").outerHeight();
//     //         $("html, body").animate({
//     //             scrollTop: offsetTop
//     //         });
//     //     }
//     // });
//     // $(".Hero-feed--slider").flickity({
//     //     contain: true,
//     //     imagesLoaded: true,
//     //     pageDots: false
//     // });
//     $('.HeroSlider-container').flickity({
//         cellSelector: '.HeroSlider-slide',
//         autoPlay: 4500,
//         imagesLoaded: true,
//         pageDots: false,
//         prevNextButtons: false,
//         groupCells: 1,
//         wrapAround: true,
//         setGallerySize: false,
//         friction: 0.7,
//         cellAlign: 'center',
//     });
// });